import type { managePilots as en } from '@/i18n/locales/en/managePilots';
import type { Translation } from '@/i18n/types';

export const managePilots: Translation<typeof en> = {
  page: {
    title: 'Pilotos',
    lead: 'Todos os pilotos da plataforma, filtráveis por empresa e estado.',
    filterCompany: 'Empresa',
    filterStatus: 'Estado',
    allCompanies: 'Todas as empresas',
    allStatuses: 'Todos os estados',
    empty: 'Nenhum piloto corresponde a estes filtros.',
    rowsLabel: 'os pilotos',
    company: 'Empresa',
    name: 'Nome',
    status: 'Estado',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    departments: 'Departamentos',
  },
  status: {
    draft: 'Rascunho',
    baseline: 'Medição inicial',
    active: 'Ativo',
    interim_review: 'Avaliação intermédia',
    final_review: 'Avaliação final',
    completed: 'Concluído',
    scaled: 'Escalado',
  },
};
